<template>
  <!-- component -->
  <div class="tw-flex tw-items-center tw-justify-center">
    <!-- iPhone 15 Container -->
    <div
      class="tw-relative tw-h-[600px] tw-rounded-[45px] tw-border-8 tw-border-zinc-900 tw-shadow-[0_0_2px_2px_rgba(255,255,255,0.1)]"
      :class="{
        'tw-w-72': image,
        'tw-w-[21.5rem]': video,
      }"
    >
      <!-- Dynamic Island -->
      <!--
        <div class="tw-absolute tw-top-2 tw-left-1/2 tw-transform -tw-translate-x-1/2 tw-w-[90px] tw-h-[22px] tw-bg-zinc-900 tw-rounded-full tw-z-20"></div>
        
        <div class="tw-absolute -tw-inset-[1px] tw-border-[3px] tw-border-zinc-700 tw-border-opacity-40 tw-rounded-[37px] tw-pointer-events-none"></div>
        -->

      <!-- Screen Content -->
      <div
        class="tw-relative tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-[37px] tw-bg-zinc-900/10"
      >
        <template v-if="image">
          <library-image :src="image" :w-ratio="1" :h-ratio="2.15" />
        </template>

        <template v-else-if="video">
          <video
            ref="videoElement"
            :src="video"
            :poster="poster"
            style="aspect-ratio: 9/16; object-fit: cover; width: 100%; height: 100%"
            controls
            playsinline
            webkit-playsinline
            preload="metadata"
            class="tw-w-full tw-h-full"
            @click="handleVideoClick"
          ></video>
        </template>
      </div>

      <!-- Left Side Buttons -->
      <!-- Silent Switch -->
      <div
        class="tw-absolute tw-left-[-12px] tw-top-20 tw-h-8 tw-w-[6px] tw-rounded-l-md tw-bg-zinc-900 tw-shadow-md"
      ></div>

      <!-- Volume Up -->
      <div
        class="tw-absolute tw-left-[-12px] tw-top-36 tw-h-12 tw-w-[6px] tw-rounded-l-md tw-bg-zinc-900 tw-shadow-md"
      ></div>

      <!-- Volume Down -->
      <div
        class="tw-absolute tw-left-[-12px] tw-top-52 tw-h-12 tw-w-[6px] tw-rounded-l-md tw-bg-zinc-900 tw-shadow-md"
      ></div>

      <!-- Right Side Button (Power) -->
      <div
        class="tw-absolute tw-right-[-12px] tw-top-36 tw-h-16 tw-w-[6px] tw-rounded-r-md tw-bg-zinc-900 tw-shadow-md"
      ></div>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default {
  name: 'Iphone15Mockup',

  mixins: [ComponentMixin],

  props: {
    image: {
      type: String,
      required: false,
      default: undefined,
    },
    video: {
      type: String,
      required: false,
      default: undefined,
    },
    poster: {
      type: String,
      required: false,
      default: undefined,
    },
    component: {
      type: Object,
      required: false,
      default: undefined,
    },
  },

  methods: {
    handleVideoClick() {
      const video = this.$refs.videoElement as HTMLVideoElement | undefined;
      if (!video || !video.paused) return;

      // Safari iOS requires explicit play() call from user interaction
      video.play().catch(() => {
        // Ignore play errors - controls handle playback
      });
    },
  },
};
</script>
